import { ISessionStateService } from "./i-session-state.service";
import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable } from "rxjs";
import { ICurrentUser } from "../../models/i-current-user";

@Injectable()
export class SessionStateService implements ISessionStateService {
  private readonly _currentUser$: BehaviorSubject<ICurrentUser | null> = new BehaviorSubject<ICurrentUser | null>(null);
  public readonly currentUser$: Observable<ICurrentUser | null> = this._currentUser$.asObservable();

  public setCurrentUser(currentUser: ICurrentUser): void {
    this._currentUser$.next(currentUser);
  }

  public getCurrentUser(): ICurrentUser | null {
    return this._currentUser$.getValue();
  }
}
